import { StyledShareButtonContainer, StyledShareButtonLink } from 'components/Selfiebooth/ShareDisplay/styled'
import React, { useState } from 'react'
import { FiCheck, FiLink } from 'react-icons/fi'
import { VISIT_URL } from 'consts'
import { addFileToFacebookShares } from 'store/actions/fileUpload'
import Spinner from 'components/Spinner'
import { SelfieBoothType, ShareLinkSelfieBoothType } from '../../../types/selfiebooth'
import { withTranslation } from 'react-i18next'

interface CopyLinkProps {
	app: any;
	share: ShareLinkSelfieBoothType;
	selfiebooth: SelfieBoothType;
	fileId: string;
	t: any;
}

const CopyLink = ({ app, share, fileId, selfiebooth, t }: CopyLinkProps) => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [isCopied, setIsCopied] = useState<boolean>(false);
	const urlToShare = `${VISIT_URL}/${app.id}/fbs/${fileId}/`;
	const icon = isCopied ? <FiCheck /> : <FiLink />

	const copyToClipboard = async () => {
		try {
			setIsLoading(true)
			await addFileToFacebookShares(app.id, fileId, selfiebooth.id, selfiebooth.part.shareFacebook.cardId, true, 'copy-public-link')
			await navigator.clipboard.writeText(urlToShare);
			setIsLoading(false)
			setIsCopied(true)
		} catch (err) {
			console.error("Erreur lors de la copie du lien :", err);
		}
	};

	return (
		<StyledShareButtonContainer $isSpinner={false}>
			<StyledShareButtonLink as="button" onClick={copyToClipboard} $type="copyLink">
				<i>{isLoading ? <Spinner isLoading={isLoading} style={{ top: '10px', left: '10px' }} /> : icon}</i>
				<label>{share.label || t('photobooth.copyLink')}</label>
			</StyledShareButtonLink>
		</StyledShareButtonContainer>
	);
}

export default withTranslation()(CopyLink);